<template>
  <v-card outlined class="mb-4">
    <v-card-title>Pesuaineen kulutus</v-card-title>
    <v-card-text>
      <canvas ref="chartCanvas"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import { Chart } from "chart.js/auto";

export default {
  name: "PesuaineChart",
  props: {
    historyData: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    chartInstance: null,
  }),
  watch: {
    historyData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const ctx = this.$refs.chartCanvas.getContext("2d");

      // Process data
      // historyData is [{ week: '...', checks: [...] }, ...]
      // We need to find the check that has the pesuaine measurement

      const labels = [];
      const dataPoints = [];

      // Sort historyData by week (assuming format WW/YYYY)
      // Actually the parent component provides it in reverse order (newest first) or something?
      // Let's just reverse it to show chronological order if needed.
      // The parent says: last10Weeks.reverse() -> so it's newest first?
      // Let's check the parent logic.
      // last10Weeks = allWeeksInHistory.slice(-10).reverse(); -> Newest first.
      // So we should reverse it back for the chart (Oldest -> Newest)

      const sortedData = [...this.historyData].reverse();

      sortedData.forEach((weekData) => {
        labels.push(weekData.week);

        let value = 0;
        // Find the check that contains the measurement
        // We are looking for an engine check that has 'form' array
        // and inside 'form' array, an item with id 'pesuaine_mittaus'

        for (const check of weekData.checks) {
          if (check.form && Array.isArray(check.form)) {
            const measurementItem = check.form.find(
              (item) =>
                item.id === "pesuaine_mittaus" ||
                item.title === "Pesuaineen mittaus" ||
                item.title === "Pesuhallin pesuaineen mittaus"
            );
            if (measurementItem && measurementItem.value) {
              const parsed = parseFloat(measurementItem.value);
              if (!isNaN(parsed)) {
                value = parsed;
              }
            }
          }
        }
        dataPoints.push(value);
      });

      this.chartInstance = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Pesuaineen määrä (cm)",
              data: dataPoints,
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 2,
              tension: 0.1,
              fill: true,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
              min: 0,
              max: 100,
            },
          },
          plugins: {
            annotation: {
              // We'll use a custom plugin instead of the annotation plugin dependency
            },
          },
        },
        plugins: [
          {
            id: "thresholdLine",
            beforeDraw: (chart) => {
              const {
                ctx,
                chartArea: { top, right, bottom, left, width, height },
                scales: { y },
              } = chart;
              ctx.save();
              ctx.strokeStyle = "red";
              ctx.lineWidth = 2;
              ctx.setLineDash([5, 5]);
              const yPos = y.getPixelForValue(20);

              if (yPos >= top && yPos <= bottom) {
                ctx.beginPath();
                ctx.moveTo(left, yPos);
                ctx.lineTo(right, yPos);
                ctx.stroke();

                ctx.fillStyle = "red";
                ctx.fillText("Hälytysraja (20cm)", left + 5, yPos - 5);
              }

              ctx.restore();
            },
          },
        ],
      });
    },
  },
};
</script>
